import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Alert,
  CircularProgress
} from '@mui/material';
import B2b from '../api/b2b';
import { useUser } from '../../hooks/useUser';
import PackageCard from './PackageCard';

const PackagePurchase = ({ onSelectPackage }) => {
  const { currentUser } = useUser();
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isCompany = Boolean(currentUser?.company_id || currentUser?.company);

  useEffect(() => {
    if (!isCompany) { setLoading(false); return; }
    let mounted = true;
    B2b.getPackages()
      .then((data) => {
        if (!mounted) return;
        setPackages(data?.packages || []);
      })
      .catch(() => {
        if (!mounted) return;
        setError('Não foi possível carregar os pacotes. Tente novamente.');
      })
      .finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
  }, [isCompany]);

  if (!isCompany) return null;

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }

  if (!packages.length) return null;

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>
        Adquirir pacote de consultas
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
          gap: 2
        }}
      >
        {packages.map((pkg) => (
          <PackageCard key={pkg.id} pkg={pkg} onBuy={onSelectPackage} ctaLabel="Comprar" />
        ))}
      </Box>
    </Box>
  );
};

export default PackagePurchase;
